import {db} from "@/modules/localDB/localDB"

const saveLastRead = async (currentPage) => {

    const record = await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .toArray();

    console.log("record:");
    console.log(record);

    if (record.length) {
        return  await db.reader
            .where("[membercode+ebookcode]")
            .equals([localStorage.membercode, localStorage.ebookcode])
            .modify({lastRead: currentPage});
    } else {
        return await db.reader.add({
            membercode: localStorage.membercode,
            ebookcode: localStorage.ebookcode,
            lastRead: currentPage
        })
    }

}

export { saveLastRead }